var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 5C9.98 5 5.5 9.48 5.5 15C5.5 20.52 9.98 25 15.5 25C21.02 25 25.5 20.52 25.5 15C25.5 9.48 21.02 5 15.5 5ZM16.5 22H14.5V20H16.5V22ZM18.57 14.25L17.67 15.17C17.17 15.68 16.81 16.14 16.63 16.86C16.55 17.18 16.5 17.54 16.5 18H14.5V17.5C14.5 17.04 14.58 16.6 14.72 16.19C14.92 15.61 15.25 15.09 15.67 14.67L16.91 13.41C17.37 12.97 17.59 12.31 17.46 11.61C17.33 10.89 16.77 10.28 16.07 10.08C14.96 9.77 13.93 10.4 13.6 11.35C13.48 11.72 13.17 12 12.78 12H12.48C11.9 12 11.5 11.44 11.66 10.88C12.09 9.41 13.34 8.29 14.89 8.05C16.41 7.81 17.86 8.6 18.76 9.85C19.94 11.48 19.59 13.23 18.57 14.25Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.24f4bd428b7c259f59bde225f859352e.svg";
export { ForwardRef as ReactComponent };